import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Collapse,
  List,
  ListItemButton,
  ListItemText,
  ChevronDownIcon,
  ChevronUpIcon,
} from "convertupleads-theme";

const EachList = ({ title, selectedTitle, onSelectTitle, submenu }) => {
  const [open, setOpen] = React.useState(false);
  const [openSubmenu, setOpenSubmenu] = React.useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setOpen((open) => !open);
  };
  const handleClickSubmenu = () => {
    setOpenSubmenu((open) => !open);
  };

  const handleSelect = (selectedTitle) => {
    onSelectTitle(selectedTitle);
  };

  return (
    <>
      <ListItemButton
        selected={selectedTitle === title && !submenu}
        onClick={
          submenu
            ? handleClick
            : () => {
                navigate("");
                handleSelect(title);
              }
        }
      >
        <ListItemText primary={title} />
        {submenu ? open ? <ChevronUpIcon /> : <ChevronDownIcon /> : ""}
      </ListItemButton>
      {submenu && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {submenu.map((list) => (
              <>
                <ListItemButton
                  selected={selectedTitle === list?.title && !list?.subMenu}
                  sx={{ pl: 4 }}
                  onClick={
                    !list?.subMenu
                      ? () => {
                          navigate(list?.link);
                          handleSelect(list?.title);
                        }
                      : handleClickSubmenu
                  }
                >
                  <ListItemText primary={list?.title} />
                  {list?.subMenu ? (
                    openSubmenu ? (
                      <ChevronUpIcon />
                    ) : (
                      <ChevronDownIcon />
                    )
                  ) : (
                    ""
                  )}
                </ListItemButton>
                {list?.subMenu && (
                  <>
                    <Collapse in={openSubmenu} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                        {list?.subMenu.map((listitem) => (
                          <ListItemButton
                            selected={selectedTitle === listitem?.title}
                            sx={{ pl: 6 }}
                            onClick={() => {
                              navigate("#");
                              handleSelect(listitem?.title);
                            }}
                          >
                            <ListItemText primary={listitem?.title} />
                          </ListItemButton>
                        ))}
                      </List>
                    </Collapse>
                  </>
                )}
              </>
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
};

export default EachList;
